import * as Types from 'src/actions/sector-of-interest/index/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import IndexResponse from 'src/value-objects/IndexResponse';
import SectorOfInterest from 'src/entities/SectorOfInterest';

export interface IndexSectorsOfInterestAttempt extends Action {
  type: Types.INDEX_SECTORS_OF_INTEREST_ATTEMPT;
}

export interface IndexSectorsOfInterestSuccess extends Action {
  type: Types.INDEX_SECTORS_OF_INTEREST_SUCCESS;
  payload: SectorOfInterest[];
}

export interface IndexSectorsOfInterestFailure extends Action {
  type: Types.INDEX_SECTORS_OF_INTEREST_FAILURE;
}

export type IndexSectorsOfInterestAction = IndexSectorsOfInterestAttempt |
  IndexSectorsOfInterestSuccess |
  IndexSectorsOfInterestFailure;

export interface IndexSectorsOfInterestThunk extends
  ThunkAction<Promise<IndexSectorsOfInterestAction>, RootState, string> {
}

export const indexSectorsOfInterestAttempt: ActionCreator<IndexSectorsOfInterestAttempt> = () => (
  {
    type: Types.INDEX_SECTORS_OF_INTEREST_ATTEMPT
  }
);

export const indexSectorsOfInterestSuccess: ActionCreator<IndexSectorsOfInterestSuccess> = (
  sectors: SectorOfInterest[]) => (
    {
      type: Types.INDEX_SECTORS_OF_INTEREST_SUCCESS,
      payload: sectors
    }
  );

export const indexSectorsOfInterestFailure: ActionCreator<IndexSectorsOfInterestFailure> = () => (
  {
    type: Types.INDEX_SECTORS_OF_INTEREST_FAILURE
  }
);

export const indexSectorsOfInterest: ActionCreator<IndexSectorsOfInterestThunk> =
  (status: string, key: string, limit?: number): IndexSectorsOfInterestThunk => {
    return (dispatch: Dispatch<RootState>): Promise<IndexSectorsOfInterestAction> => {
      dispatch(indexSectorsOfInterestAttempt());

      return ApiClient.constants.indexSectorsOfInterest()
        .then((response: AxiosResponse<IndexResponse<SectorOfInterest>>): IndexSectorsOfInterestSuccess => {
          return dispatch(indexSectorsOfInterestSuccess(response.data.content));
        }).catch((): IndexSectorsOfInterestFailure => {
          return dispatch(indexSectorsOfInterestFailure());
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/sector-of-interest/index/IndexSectorsOfInterest.actions.tsx